import React from "react";
import CaroselloHome from "../components/home/CaroselloHome";
import "../styles/Home.css";
import { useNavigate } from "react-router-dom";
import GroupCard from "../components/home/GroupCard";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import Space from "../commons/Space";
import TitoloSezioni from "../commons/TitoloSezioni";
import SpaceL from "../commons/SpaceL";
import { Helmet } from "react-helmet";
import { motion } from 'framer-motion';

// Importa le immagini qui
import fotoHome from "../images/home/IMG_8672-2.jpg"
import squadra from "../images/Evidenza/Ago2.png";
import chiusura from "../images/Evidenza/Card_chiusura.png"
import ballo from "../images/home/copertine2025/Ballo.png"

import promoprima26 from "../images/News/CardPromoPrimavera26.png";
import pasqua26 from "../images/News/Copertina_pasqua.png";
import gare from "../images/News/CopertinaGare.png";

import CardInEvidenzaFoto from "../components/CardInEvidenzaFoto";
import CardNewsEvidenzaFoto from "../components/CardNewsEvidenzaFoto";

import CardInEvidenza from "../components/CardInEvidenza";
import NewCard from "../components/home/NewCard";

interface HomeProps {}

function Home(_: HomeProps) {
    const navigate = useNavigate();

    return (
        <div>
            <Helmet>
                <title>Centro Sportivo Il Cigno</title>
                <meta name="description" content="Piscina, Palestra, Danza, Fitness, Runnering, SPA" />
                <link rel="preload" href={fotoHome} as="image" />
            </Helmet>

            <ScrollToTopOnMount />
            <CaroselloHome />

            <div className="d-none d-sm-block"><Space /></div>
            <div className="d-block d-sm-none"><SpaceL /></div>



            <div className="m-auto" style={{maxWidth: "90%"}}>



                <div className="d-none d-sm-block" >
                    <p style={{fontSize: "32px"}}><strong>In evidenza</strong></p>
                    <hr/>

                    <div style={{ display: "flex", flexDirection: "row", overflowX: "auto" }}>
                        <CardInEvidenzaFoto foto={gare} width={"100%"} posizioneFoto={"center"} indirizzo={"./news/gareSociali2026"} />
                    </div>

                </div>

                <div className="d-sm-none  " >
                    <p style={{fontSize: "22px"}}><strong>In evidenza</strong></p>
                    <hr/>
                    <div className="card-container" style={{ display:"flex", flexDirection: "row" , overflowX: "auto" }}>
                        <CardNewsEvidenzaFoto foto={gare} width={"100%"} indirizzo={"./news/gareSociali2026"} posizioneFoto={"center"} />
                    </div>
                </div>


            </div>
            
            <div className="d-none d-sm-block"><Space /></div>
            <div className="d-block d-sm-none"><SpaceL /></div>

            <div className="d-flex flex-column align-items-center">
                <TitoloSezioni title="Attività" />
                <GroupCard />
                <SpaceL />
                <TitoloSezioni title={"Novità 2025"} />
                <NewCard coloreSettore={"#7E0303"} image={ballo} title={"Ballo"} indirizzo={"/ballo"} />
                <Space />
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <motion.div
                            className="box"
                            whileHover={{ scale: 1.2 }}
                            whileTap={{ scale: 0.9 }}
                            transition={{ type: "spring", stiffness: 400, damping: 17 }}
                        ><button
                            style={{ maxWidth: "30em", minWidth: "20em", height: "8em", borderRadius: "1em", borderColor: "#032041", borderWidth: "0.3em" }}
                            type="button" className="btn custom-btn"
                            onClick={() => navigate("/chisiamo")}
                        >
                            <TitoloSezioni title={"Scopri il centro"} />

                        </button></motion.div>
                    </blockquote>
                </figure>
            </div>

            <SpaceL />
        </div>
    );
}

export default Home;
